import {
  Project,
  Skeleton,
  DocumentModel,
  Node,
  NodeChildren,
  History,
  SettingPropEntry,
  SettingTopEntry,
  Selection,
  Prop,
  SimulatorHost,
} from '@alilc/lowcode-shell';
import { Node as InnerNode } from '@alilc/lowcode-designer';

export default {
  Project,
  Skeleton,
  DocumentModel,
  Node,
  NodeChildren,
  History,
  SettingPropEntry,
  SettingTopEntry,
  InnerNode,
  Selection,
  Prop,
  SimulatorHost,
};
